<template>
    <div class="campaign-option">
        <div class="campaign-option--title">
            Tags
            <info-tooltip text="Select the tags you wish to apply to this ad set."></info-tooltip>
        </div>

        <div class="campaign-adset-location__input">
            <multiselect
                    v-model="selectedTags"
                    :multiple="true"
                    :options="options"
                    label="label"
                    :close-on-select="false"
                    :hide-selected="true"
                    track-by="id"
                    :placeholder="placeholder"
                    :show-labels="false">
            </multiselect>
        </div>
    </div>
</template>

<script>
  import Multiselect from 'vue-multiselect'

  export default {
    components: { Multiselect },

    props: {
      value: Array,
      options: Array
    },

    data() {
      return {
        selectedTags: this.value
      }
    },

    watch: {
      selectedTags() {
        this.$emit('input', this.selectedTags);
      }
    },

    computed: {
      placeholder() {
        if (this.selectedTags.length > 0) {
          return '';
        } else {
          return 'Optional - Choose Tags';
        }
      }
    }
  }
</script>
